import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Approve from '@wix/da-ds/pkg/Icons/24x24/Approve';
import verificationReminderStyles from './VerificationReminder.scss';
export const VerificationResent = ({ email })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(verificationReminderStyles['root'], verificationReminderStyles['sent'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: verificationReminderStyles['check']
    }, /*#__PURE__*/ React.createElement(Approve, {
        customSizable: true
    })), /*#__PURE__*/ React.createElement("div", {
        className: verificationReminderStyles['text']
    }, t('siteHeader.verification.sent')), /*#__PURE__*/ React.createElement("div", {
        className: verificationReminderStyles['email'],
        title: email
    }, email));
};
VerificationResent.displayName = 'VerificationResent';
export default VerificationResent;
